module.exports = __webpack_public_path__ + "img/Metastasis-LUCA_10X_LU.f4350283.png";